'use client';

import classnames from 'classnames';

import { Text } from '../../text';
import { ScoreSummary } from '../layout/ScoreSummary';
import type { AssessmentAttemptResultPreviewProps } from './AssessmentAttemptResultPreview.types';

import styles from './AssessmentAttemptResultPreview.module.scss';

function AssessmentAttemptResultPreview({
  style,
  className,
  title,
  score,
  elapsedTime,
  description,
  answerRate,
  submittedDate,
  onClick,
  testId = 'ui-result-preview',
}: AssessmentAttemptResultPreviewProps) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      onClick={onClick}
      data-testid={testId}
    >
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <h3 className={styles['title__text']}>{title}</h3>
          <h4 className={styles['title__subtitle']}>{description}</h4>
        </div>
        <Text
          variety="annotation"
          font="monospace"
          data-testid={`${testId}_date`}
        >
          {submittedDate}
        </Text>
      </div>
      <ScoreSummary
        className={styles['score']}
        score={score}
        answerRate={answerRate}
        elapsedTime={elapsedTime}
        cutout="80%"
      />
    </div>
  );
}

export { AssessmentAttemptResultPreview };
